import { default as VuxEnumManager, Enum } from 'ivux-enum-manager/src/index'

export default function(Vue, options = {}) {
	var { router, store, i18n, config } = options

	// install ivux-enum-manager
	VuxEnumManager(Vue, {
		// 全局枚举
		globalEnum: config.globalEnum,
		// 翻译函数
		translate: i18n ? path => i18n.t(path) : null
	})
}